module.exports = __webpack_public_path__ + "img/IMGP8637b.49c2ab08.jpg";